import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../components/common/InputField";
import Button from "../../components/common/Button";
import NavigationBar from "../../components/common/NavigationBar";
import SelectElement from "../../components/common/SelectElement";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getCurrentUserData,
  updateCurrentUserData,
  manuallyTrigerSuccess,
  updateCurrentUserPassword,
} from "../../redux/actions/currentUserActions";

import { updateCertainPaper } from "../../redux/actions/papersActions";

import { logout } from "../../redux/actions/loginAction";

// Scss imports
import css from "./EditPaper.module.scss";

interface EditPaperProps {
  text?: string;
}

const EditPaper: React.FC<EditPaperProps> = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const certainPaperData = useSelector(
    (state: any) => state.papers.certainPaper
  );

  const activeProcessors = useSelector(
    (state: any) => state.allProcessors.processorsActive
  );

  // Recipients/Senders
  const allRecipientsSenders = useSelector(
    (state: any) => state.papers.recipientAndSenders
  );

  // Curent user data
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  // Updation fields status
  const updateCurrentUserDataStatus = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataStatus
  );

  // Updating fields error
  const updateCurrentUserDataError = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataError
  );
  // Setting up state to hold data for forms
  const [senderPaperNumber, setSenderPaperNumber] = useState(
    certainPaperData.senderPaperNumber
  );
  const [shortText, setShortText] = useState(certainPaperData.shortText);
  const [remark, setRemark] = useState(certainPaperData.remark);
  const [paperType, setPaperType] = useState(currentUserData.paperType);
  const [date, setDate] = useState(
    certainPaperData.senderDate ? certainPaperData.senderDate.split("T")[0] : ""
  );
  const [actNumber, setActNumber] = useState("");
  const [processor, setProcessor] = useState();
  const [recipientSender, setRecipientSender] = useState();
  const [sendingBlock, setSendingBlock] = useState("");
  const [processorsListArray, setProcessorsListArray] = useState<any>(
    activeProcessors.data
  );

  // messages text states
  const [messageBasicAccountText, setMessageBasicAccoutText] = useState("");

  // status for disabled password button
  const [disabledPaswordButton, setDisabledPaswordButton] = useState(false);

  const [recipientsSendersListArray, setRecipientsSendersListArray] =
    useState<any>(allRecipientsSenders);

  useEffect(() => {
    if (sendingBlock === "basicData") {
      handleMessageText(setMessageBasicAccoutText);
    }
  }, [updateCurrentUserData, updateCurrentUserDataStatus]);

  useEffect(() => {
    setMessageBasicAccoutText("");
    const recipientSendersListArray =
      allRecipientsSenders.length > 0
        ? allRecipientsSenders.map((element) => {
            return {
              value: element.recSendName,
              name: element.recSendName,
            };
          })
        : [];

    allRecipientsSenders.length > 0
      ? setRecipientsSendersListArray([
          { value: "", name: "Изабери" },
          ...recipientSendersListArray,
        ])
      : setRecipientsSendersListArray([]);
    const processorsListArray =
      activeProcessors.data.length > 0
        ? activeProcessors.data.map((element) => {
            return {
              value: element._id,
              name: element.firstName + " " + element.lastName,
            };
          })
        : [];

    if (activeProcessors.data.length > 0) {
      setProcessorsListArray([
        { value: "", name: "Изабери" },
        ...processorsListArray,
      ]);
    }

    //setSenderPaperNumber(certainPaperData.senderPaperNumber);
  }, []);

  // Handling input change
  const handleChange = (e: any, setValue) => {
    setValue(e.target.value);
    setMessageBasicAccoutText("");
    dispatch(manuallyTrigerSuccess());
  };

  // Function for checking is object empty
  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  // Function for sending data to the database with certain conditions
  const sendDataToTheDatabase = (object, formData, setMessageText) => {
    if (!isEmpty(object)) {
      dispatch(updateCertainPaper(formData(), certainPaperData.id, history));
    } else {
      setMessageText("Није промењено ниједно поље!");

      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  // Event for sending basic data to the database
  const sendBasicDataEvent = () => {
    const basicDataFormIncoming = () => {
      console.log(certainPaperData.paperType);
      return {
        ...(senderPaperNumber !== certainPaperData.senderPaperNumber && {
          senderPaperNumber: senderPaperNumber,
        }),
        ...(shortText !== certainPaperData.shortText && {
          shortText: shortText,
        }),
        ...(remark !== certainPaperData.remark && {
          remark: remark,
        }),
        ...(paperType !== certainPaperData.paperType && {
          paperType: paperType,
        }),
        ...(recipientSender !== certainPaperData.recipientSender && {
          recipientSender: recipientSender,
        }),
        ...(processor !== certainPaperData.processor && {
          processor: processor,
        }),
        ...(date !== certainPaperData.senderDate && {
          senderDate: date,
        }),
      };
    };

    const basicDataFormOutgoing = () => {
      console.log(certainPaperData.paperType);
      return {
        ...(shortText !== certainPaperData.shortText && {
          shortText: shortText,
        }),
        ...(remark !== certainPaperData.remark && {
          remark: remark,
        }),
        ...(paperType !== certainPaperData.paperType && {
          paperType: paperType,
        }),
        ...(recipientSender !== certainPaperData.recipientSender && {
          recipientSender: recipientSender,
        }),
        ...(processor !== certainPaperData.processor && {
          processor: processor,
        }),
      };
    };

    if (certainPaperData.paperType === "outgoing") {
      setSendingBlock("basicData");

      const objectOutgoing: any = basicDataFormOutgoing();

      sendDataToTheDatabase(
        objectOutgoing,
        basicDataFormOutgoing,
        setMessageBasicAccoutText
      );
    } else {
      setSendingBlock("basicData");

      const objectIncoming: any = basicDataFormIncoming();

      sendDataToTheDatabase(
        objectIncoming,
        basicDataFormIncoming,
        setMessageBasicAccoutText
      );
    }
  };

  // function for handling error/success messages
  const handleMessageText = (setMessageText) => {
    if (updateCurrentUserDataStatus === "fail") {
      setMessageText(updateCurrentUserDataError);
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    } else if (updateCurrentUserDataStatus === "success") {
      setMessageText("Успешно сте променили основне податке профила!");
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
  };

  const paperTypeArray = [
    {
      value: "",
      name: "Изабери",
    },
    {
      value: "incoming",
      name: "Долазна",
    },
    {
      value: "outgoing",
      name: "Одлазна",
    },
  ];

  // From recipients and senders array get array for showing recipient/senders options

  return (
    <div className={css.mainContainer}>
      <NavigationBar />
      <h1>Измени папир</h1>
      <div className={css.dataContainer}>
        {/* Basic account data */}
        <div className={css.wrapperContainer}>
          <div
            className={css.container}
            onClick={() => dispatch(getCurrentUserData())}
          >
            <div>
              <h2 className={css.title}>Тренутни подаци папира</h2>
              <hr />
              <p>
                <span>Тип папира: </span>
                {certainPaperData &&
                certainPaperData.paperType.length > 0 &&
                certainPaperData.paperType === "incoming"
                  ? "Долазни папир"
                  : "Одлазни папир"}
              </p>

              <p>
                <span>Датум: </span>
                {certainPaperData && certainPaperData.createdAt
                  ? certainPaperData.createdAt.split("T")[0]
                  : ""}
              </p>
              <p>
                <span>Архивиран: </span>
                {certainPaperData &&
                certainPaperData.arhived.length > 0 &&
                certainPaperData.arhived === "notarhived"
                  ? "Неархивиран папир"
                  : "Архивиран папир"}
              </p>

              <p>
                <span>Основни број: </span>
                {certainPaperData && certainPaperData.baseNumber
                  ? certainPaperData.baseNumber.baseNumber
                  : ""}
              </p>

              <p>
                <span>Подброј: </span>
                {certainPaperData && certainPaperData.subnumber
                  ? certainPaperData.subnumber
                  : ""}
              </p>

              <p>
                <span>Пошиљалац/Прималац: </span>
                {certainPaperData && certainPaperData.recipientSender
                  ? certainPaperData.recipientSender
                  : ""}
              </p>

              <p>
                <span>Број акта пошиљаоца: </span>
                {certainPaperData && certainPaperData.senderPaperNumber
                  ? certainPaperData.senderPaperNumber
                  : ""}
              </p>

              <p>
                <span>Датум акта пошиљаоца: </span>
                {certainPaperData && certainPaperData.senderDate
                  ? certainPaperData.senderDate.split("T")[0]
                  : ""}
              </p>

              <p>
                <span>Обрађивач: </span>
                {certainPaperData &&
                certainPaperData.processor.firstName &&
                certainPaperData.processor.lastName
                  ? certainPaperData.processor.firstName +
                    " " +
                    certainPaperData.processor.lastName
                  : ""}
              </p>

              <p>
                <span>Кратак садржај: </span>
                {certainPaperData && certainPaperData.shortText
                  ? certainPaperData.shortText
                  : ""}
              </p>

              <p>
                <span>Напомена: </span>
                {certainPaperData && certainPaperData.remark
                  ? certainPaperData.remark
                  : ""}
              </p>
            </div>

            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {certainPaperData.paperType === "incoming" && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Број акта пошиљаоца"
                      name="senderPaperNumber"
                      id="senderPaperNumber"
                      type="text"
                      value={senderPaperNumber}
                      handleChange={(e: any) =>
                        handleChange(e, setSenderPaperNumber)
                      }
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Кратак садржај"
                    name="shortText"
                    id="shortText"
                    type="text"
                    value={shortText}
                    handleChange={(e: any) => handleChange(e, setShortText)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Напомена"
                    name="remark"
                    id="remark"
                    type="text"
                    value={remark}
                    handleChange={(e: any) => handleChange(e, setRemark)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    inputType="rowInput"
                  />
                </div>
                {certainPaperData.paperType === "incoming" && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Датум акта пошиљаоца"
                      name="date"
                      id="date"
                      type="date"
                      value={date}
                      handleChange={(e: any) => handleChange(e, setDate)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}

                {/*<div className={css.selectWrapper}>
                  <SelectElement
                    label="Тип папира"
                    id="paperType"
                    name="paperType"
                    handleChange={(e) => onSelectChange(e, setPaperType)}
                    selectOptionsArray={paperTypeArray}
                    minLabelWidth={true}
                    type="marginTopSelect"
                  />
                    </div>*/}
                <div className={css.selectWrapper}>
                  <SelectElement
                    label="Пошиљалац/Прималац"
                    id="recipientSender"
                    name="recipientSender"
                    handleChange={(e) => onSelectChange(e, setRecipientSender)}
                    selectOptionsArray={recipientsSendersListArray}
                    minLabelWidth={true}
                    type="marginTopSelect"
                  />
                </div>
                <div className={css.selectWrapper}>
                  <SelectElement
                    label="Обрађивач"
                    id="processor"
                    name="processor"
                    handleChange={(e) => onSelectChange(e, setProcessor)}
                    selectOptionsArray={processorsListArray}
                    minLabelWidth={true}
                    type="marginTopSelect"
                  />
                </div>
                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={sendBasicDataEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${css.messageText} ${
              messageBasicAccountText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageBasicAccountText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPaper;
